import validate from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "get-globals-middleware": () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/middleware/get-globals-middleware.js"),
  "resolve-segment-middleware": () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/middleware/resolve-segment-middleware.js"),
  "update-chat-middleware": () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/middleware/update-chat-middleware.js")
}